import { styles } from "./TableHeadSortable.style";

import * as React from "react";
import {
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    WithStyles,
    withStyles
} from "../../../node_modules/@material-ui/core";

interface TableHeadSortableProps {
    order: "asc" | "desc";
    orderBy: string;
    rows: {
        id: string;
        label: string;
    }[];
    onRequestSort(property: string);
}

class TableHeadSortable extends React.Component<TableHeadSortableProps & WithStyles<typeof styles>> {

    public render() {

        const { order, orderBy, rows } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => (
                        <TableCell
                            key={row.id}                            
                            sortDirection={orderBy === row.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === row.id}
                                direction={order}
                                onClick={_ => this.props.onRequestSort(row.id)}
                            >
                                {row.label}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                    <TableCell>&nbsp;</TableCell>
                </TableRow>
            </TableHead>
        );

    }
}

export default withStyles(styles)(TableHeadSortable);


// WEBPACK FOOTER //
// ./src/components/TableHeadSortable/TableHeadSortable.tsx